import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styles from './styles.scss';

const Input = ({ className, validations, onChange, onBlur, unit, ...rest }) => {

  const [errors, setErrors] = useState([]);

  const validate = (value) => {
    setErrors([]);
    const results = validations.map(v => v(value));
    if (_.reject(results, _.isEmpty).length) {
      setErrors(results);
    }
  };

  const changeHandler = (e) => {
    if (onChange) {
      validate(e.target.value);
      onChange(e);
    }
  };

  const blurHandler = (e) => {
    if (onBlur) {
      validate(e.target.value);
      onBlur(e);
    }
  };

  const klassName = className || styles.default;
  return (
    <div>
      <input className={klassName} onChange={changeHandler} onBlur={blurHandler} {...rest} />
      {unit}
      {errors.map(error => (<div className={styles['error-msg']} key={error}>{ error }</div>))}
    </div>
  );
};

Input.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  validations: PropTypes.arrayOf(PropTypes.func),
  unit: PropTypes.node,
};

Input.defaultProps = {
  onChange: null,
  onBlur: null,
  className: '',
  validations: [],
  unit: '',
};

export default Input;
